module.exports = __webpack_public_path__ + "img/重庆理工大学.49a518d2.png";